import type { OperationsSnapshot, WorkBlock, WorkTask } from "../../domain/operations";
import { TaskRow } from "./TaskRow";
import { TimeRail } from "./TimeRail";

export function ExpandedBlock({ block, tasks, snapshot, onStatus }: { block: WorkBlock; tasks: WorkTask[]; snapshot: OperationsSnapshot; onStatus: (id: string, status: WorkTask["status"]) => void }) {
  const complete = tasks.filter((task) => task.status === "complete").length;
  return (
    <article className="work-block active-block">
      <div className="block-head">
        <TimeRail block={block} />
        <div className="block-title">
          <div className="location-icon">⌖</div>
          <div><h3>{block.title}</h3><p>{block.timeframe} · {tasks.length} tasks · {block.staffIds.length} staff</p></div>
        </div>
        <div className="block-progress"><span><b>{complete}</b> of {tasks.length} complete</span><div><i style={{ width: `${tasks.length ? (complete / tasks.length) * 100 : 0}%` }} /></div></div>
      </div>
      <div className="task-table" role="table" aria-label={`${block.title} tasks`}>
        <div className="task-row table-head" role="row"><span>Work</span><span>Event</span><span>Class</span><span>Assigned</span><span>Status</span><span /></div>
        {tasks.map((task) => <TaskRow key={task.id} task={task} snapshot={snapshot} onStatus={onStatus} />)}
      </div>
    </article>
  );
}
